/* eslint-disable react/jsx-props-no-spreading */
/* Refer to https://github.com/LottieFiles/lottie-react/ for usage pattern */
import { useRef, useState } from 'react';
import styled from '@emotion/styled';
import useMounted from '@hooks/useMounted';
import Dynamic from '@base/Dynamic/Dynamic';

const Player = Dynamic(
  () =>
    import('@lottiefiles/react-lottie-player').then((module) => module.Player),
  { ssr: false }
);

const AnimationContainer = styled.div``;

const LottieAnimation = ({
  src,
  style = {},
  className = undefined,
  Fallback = undefined,
  Skeleton = undefined,
  autoplay = true,
  loop = true,
  events = {},
  ...options
}) => {
  const player = useRef(null);

  const { controls = false, mode = 'normal' } = options;

  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const optionsToPass = {};
  if (autoplay) optionsToPass.autoplay = autoplay;
  if (controls) optionsToPass.controls = controls;
  if (mode) optionsToPass.mode = mode;
  if (loop) optionsToPass.loop = loop;

  const isMounted = useMounted();

  const onEvent = (e) => {
    if (e === 'error') {
      setHasError(true);
      setIsLoading(false);
    }
    if (e === 'load') {
      setHasError(false);
      setIsLoading(false);
    }
    if (events[e]) events[e](e);
  };

  return (
    <AnimationContainer className={className} style={style}>
      {isLoading && (Skeleton || '')}
      {isMounted &&
        (hasError ? (
          Fallback || Skeleton || ''
        ) : (
          <Player ref={player} src={src} onEvent={onEvent} {...optionsToPass} />
        ))}
    </AnimationContainer>
  );
};

export default LottieAnimation;
